var _circle, _circle2, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 34.507,
    r: 29.0775,
    stroke: "#C5FF49"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 34.507,
    r: 5.91549,
    fill: "#C5FF49"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 2.18557e-8,
    x2: 36,
    y2: 11.831,
    stroke: "#C5FF49"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 34.0071,
    x2: 12.331,
    y2: 34.0071,
    stroke: "#C5FF49"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 58.1691,
    x2: 36,
    y2: 70.0001,
    stroke: "#C5FF49"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 58.669,
    y1: 34.0071,
    x2: 70.5,
    y2: 34.0071,
    stroke: "#C5FF49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.88b18d24452fcea1c1cc26e4f57c91db.svg";
export { ForwardRef as ReactComponent };